"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_1 = require("../base");

var algorithm_1 = require("../algorithm");

var comparators_1 = require("../functional/comparators");

function erase(container, val) {
  return erase_if(container, function (elem) {
    return comparators_1.equal_to(elem, val);
  });
}

exports.erase = erase;

function erase_if(container, predicator) {
  if (container.remove_if instanceof Function) container.remove_if(predicator);else if (container.at instanceof base_1.ArrayContainer) {
    var it = algorithm_1.remove_if(container.begin(), container.end(), predicator);
    container.erase(it, container.end());
  } else {
    for (var it = container.begin(); !it.equals(container.end());) {
      if (predicator(it.value)) it = container.erase(it);else it = it.next();
    }
  }
}

exports.erase_if = erase_if;